import { render } from "./Video.vue?vue&type=template&id=2931c2fc"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"

import "./Video.vue?vue&type=style&index=0&id=2931c2fc&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Taitaen Swegon Prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__